import React from "react";
import { FileText } from "@semo/icons";
import { Button } from "../primitives/button";
import { openInnopayReceipt } from "@semo/shared-utils";
import { cn } from "../utils";

export interface ReceiptButtonProps extends React.ComponentProps<
  typeof Button
> {
  tid: string;
}

export const ReceiptButton = ({
  tid,
  className,
  variant = "outline",
  size = "sm",
  children,
  ...props
}: ReceiptButtonProps) => {
  return (
    <Button
      variant={variant}
      size={size}
      className={cn("gap-1.5", className)}
      onClick={(e) => {
        e.stopPropagation(); // Prevent row click bubbling if used in table rows
        openInnopayReceipt(tid);
      }}
      {...props}
    >
      <FileText className="w-3.5 h-3.5" />
      {children ?? "영수증"}
    </Button>
  );
};
